<template>
  <div class="ratings">
    <div
      v-if="rating"
      class="flex flex-col items-start"
    >
      <!-- star icons -->
      <div class="stars flex justify-center items-center">
        <span
          v-for="(type, i) in stars"
          :key="i"
        >
          <!-- full star -->
          <span
            v-if="type === 'full'"
            class="text-primary-charlie text-xl mr-0.5"
          >★</span>

          <!-- half star -->
          <span
            v-else-if="type === 'half'"
            class="relative text-gray-200 text-xl mr-0.5"
          >
            <span class="absolute top-[-3px] left-0 overflow-hidden w-1/2 text-primary-charlie">
              ★
            </span>
            ★
          </span>

          <!-- empty star -->
          <span
            v-else
            class="text-gray-200 text-xl mr-0.5"
          >★</span>
        </span>

        <strong class="ml-2">{{ rating.averageUserRating.toFixed(1) }}</strong>
      </div>

      <!-- numeric display -->
      <div class="mt-1">
        <small class="text-sm text-gray-500">
          ({{ formatCount(rating.userRatingCount) }} beoordelingen)
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AppStoreRating',
  data() {
    return {
      rating: { averageUserRating: 4.7405, userRatingCount: 6586 } // falback,
    };
  },
  computed: {
    stars() {
      const avg = this.rating.averageUserRating;
      const fullStars = Math.floor(avg);
      const hasHalf = avg - fullStars >= 0.5;
      const emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);

      return [
        ...Array(fullStars).fill('full'),
        ...(hasHalf ? ['half'] : []),
        ...Array(emptyStars).fill('empty'),
      ];
    },
  },
  async mounted() {
    try {
      const { data } = await axios.get('https://itunes.apple.com/lookup', {
        params: { id: '6469503953', country: 'nl' },
        headers: { Accept: 'application/json' },
      });
      if (data.resultCount > 0) {
        const { averageUserRating, userRatingCount } = data.results[0];
        this.rating = { averageUserRating, userRatingCount };
      }
    } catch (err) {
      console.error('Failed to fetch App Store rating:', err);
    }
  },
  methods: {
    formatCount(n) {
      return n > 1000 ? (n / 1000).toFixed(1) + 'k' : n;
    },
  },
};
</script>
